import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService, { microServices } from 'network/apis/index'

export const placeBetRouletteGameService = ({ ...data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/roulette/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsRouletteService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/roulette/my-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const rouletteCheckFairness = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/roulette/check-fairness', data, {
    server: microServices.USER_URL
  })
}
